import { useEffect, useState } from "react";

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";

// Settings page components
import FormField from "layouts/pages/account/components/FormField";

import AuthService from "services/auth-service";

// The API returns ISO timestamps; <input type="date"> only accepts YYYY-MM-DD.
const toDateInput = (value) => (value ? String(value).slice(0, 10) : "");

function BasicInfo({ user, isDemo }) {
  const [info, setInfo] = useState({ name: "", email: "", title: "", birthday: "", start:"" });
  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });

  const [errors, setErrors] = useState({
    nameError: false,
    emailError: false,
  });

  useEffect(() => {
    setInfo({
      name: user.name,
      email: user.email,
      title: user.title || "",
      birthday: user.birthday || "",
      start: user.start || "",
    });
  }, [user]);

  useEffect(() => {
    if (notification.value === true) {
      const timer = setTimeout(() => {
        setNotification({ value: false, color: "info", message: "" });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const changeHandler = (e) => {
    setInfo({
      ...info,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const mailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (info.name.trim().length === 0) {
      setErrors({ ...errors, nameError: true });
      return;
    }

    if (info.email.trim().length === 0 || !info.email.trim().match(mailFormat)) {
      setErrors({ ...errors, emailError: true });
      return;
    }

    const userData = {
      data: {
        type: "profile",
        attributes: {
          name: info.name,
          email: isDemo ? undefined : info.email,
          title: info.title,
          birthday: info.birthday,
          start: info.start,
        },
      },
    };

    try {
      await AuthService.updateProfile(userData);

      // ✅ PROFİL GÜNCELLENDİKTEN SONRA BİLGİLERİ YENİDEN ÇEK
      const updated = await AuthService.getProfile();
      setInfo({
        name: updated.data.attributes.name,
        email: updated.data.attributes.email,
        title: updated.data.attributes.title || "",
        birthday: toDateInput(updated.data.attributes.birthday),
        start: toDateInput(updated.data.attributes.start),
      });

      setNotification({
        value: true,
        color: isDemo ? "secondary" : "info",
        message: isDemo
            ? "You can not update the email in demo version"
            : "Your profile has been updated",
      });

      setErrors({ nameError: false, emailError: false });
    } catch (err) {
      setNotification({
        value: true,
        color: "error",
        message: "Profile update failed",
      });
    }
  };


  return (
      <>
        <Card id="basic-info" sx={{ overflow: "visible" }}>
          <MDBox p={3}>
            <MDTypography variant="h5">Basic Info</MDTypography>
          </MDBox>
          <MDBox component="form" pb={3} px={3} method="POST" onSubmit={submitHandler}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <FormField
                    label="First Name"
                    placeholder="Alec"
                    name="name"
                    value={info.name}
                    onChange={changeHandler}
                    error={errors.nameError}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormField
                    label="Email"
                    placeholder="example@email.com"
                    inputProps={{ type: "email" }}
                    name="email"
                    value={info.email}
                    onChange={changeHandler}
                    error={errors.emailError}
                    disabled={isDemo}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormField
                    label="Title"
                    placeholder="Manager"
                    name="title"
                    value={info.title}
                    onChange={changeHandler}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormField
                    label="Birthday"
                    name="birthday"
                    inputProps={{ type: "date" }}
                    value={info.birthday}
                    onChange={changeHandler}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <FormField
                    label="Start"
                    name="start"
                    inputProps={{ type: "date" }}
                    value={info.start}
                    onChange={changeHandler}
                />
              </Grid>
            </Grid>
            <MDBox ml="auto" mt={2} display="flex" justifyContent="flex-end">
              <MDButton variant="gradient" color="dark" size="small" type="submit">
                update
              </MDButton>
            </MDBox>
          </MDBox>
        </Card>
        {notification.value === true && (
            <MDAlert color={notification.color} mt="20px">
              <MDTypography variant="body2" color="white">
                {notification.message}
              </MDTypography>
            </MDAlert>
        )}
      </>
  );
}

export default BasicInfo;
